import axios from 'axios';
import {getApiConfig} from '../config/configProvider';

export default class creditTermsApi {
  // Submits a monthly-credit application. The customer's C-account is read from
  // the bearer token by credit-check-svc; the body carries the company + director.
  static applyForCredit(data, headers) {
    const config = getApiConfig();
    // The ecom gateway maps /api/credit-check in every environment, so fall back
    // to the fixed relative path. The deployed runtime CONFIG_JS does not carry
    // creditCheckUrl, which otherwise yields "/undefined/credit-applications".
    const baseUrl = config.creditCheckUrl || '/api/credit-check/api/v1';
    const url = `${baseUrl}/credit-applications`;
    return axios.post(url, data, {headers}).then(res => res.data);
  }

  // Looks up a company by its Companies House number so the customer can confirm
  // the right company before applying. Returns {companyNumber, companyName,
  // companyStatus, registeredAddress}; a 404 means no company matched.
  static lookupCompany(companiesHouseNumber, headers) {
    const config = getApiConfig();
    const baseUrl = config.creditCheckUrl || '/api/credit-check/api/v1';
    const url = `${baseUrl}/credit-applications/company/${encodeURIComponent(
      companiesHouseNumber
    )}`;
    return axios.get(url, {headers}).then(res => res.data);
  }
}
